var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { getDisplayName } from '@hilma/tools';
import { useKlskDhp, useIsAuthenticated } from '../hooks';
/**
 * Higher Order Component that makes component private according to the componentName and role-access-config.json
 * @param Component The Component you want to privatize
 * @param componentName The component's name that will be looked up in role-access-config.json
 * @param DefaultComponent The component that's rendered if you cant access the component
 */
var privatize = function (Component, componentName, DefaultComponent) {
    if (DefaultComponent === void 0) { DefaultComponent = function () { return null; }; }
    var Privatize = function (props) {
        var klsk = useKlskDhp().klsk;
        var isAuthenticated = useIsAuthenticated();
        if (klsk.indexOf(componentName) === -1 || !isAuthenticated)
            return React.createElement(DefaultComponent, __assign({}, props));
        return React.createElement(Component, __assign({}, props));
    };
    Privatize.displayName = "privatize(" + getDisplayName(Component) + ")";
    return Privatize;
};
export default privatize;
//# sourceMappingURL=privatize.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@hilma/auth/dist/functions/privatize.js
// module id = 106
// module chunks = 1